import apiClient from '../utils/apiClient';

export const cguService = {
  // Vérifier le statut d'acceptation des CGU
  async checkCGUStatus() {
    try {
      const response = await apiClient.get('/api/user/cgu-status');
      return response.data;
    } catch (error) {
      console.error('Erreur vérification statut CGU:', error);
      throw error;
    }
  },

  // Accepter les CGU
  async acceptCGU(version = '1.0') {
    try {
      const response = await apiClient.post('/api/user/accept-cgu', { version });
      return response.data;
    } catch (error) {
      console.error('Erreur acceptation CGU:', error);
      throw error;
    }
  },

  // Refuser les CGU (pour traçabilité)
  async declineCGU() {
    try {
      const response = await apiClient.post('/api/user/decline-cgu');
      return response.data;
    } catch (error) {
      console.error('Erreur refus CGU:', error);
      throw error;
    }
  }
};

export default cguService;
